var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductsLasso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 328,
    viewBox: "0 0 354 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M341.457 65.3568C326.347 36.7612 306.528 20.5589 280.563 16.1559C234.042 8.2672 207.984 26.7357 176.296 29.0596C144.608 31.3836 127.392 12.1592 99.1552 3.55844C77.1151 -3.15481 32.9576 9.19261 18.6852 38.9472C4.73549 68.328 -8.2365 95.4574 11.0158 133.606C29.8943 171.433 63.275 182.638 85.3897 221.628C107.504 260.617 111.25 297.711 138.399 313.391C166.868 329.832 232.356 335.109 266.999 300.614C294.863 272.869 288.92 229.701 313.664 199.528C338.409 169.356 349.201 155.236 351.038 135.641C353.576 108.553 353.804 88.724 341.457 65.3568Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsLasso);
export default __webpack_public_path__ + "static/media/products-lasso.af1cf2eae043b55c1cd6c903b70fa7d9.svg";
export { ForwardRef as ReactComponent };